import {useIntl} from 'react-intl';
import * as React from 'react';
import {useEffect, useState, useRef} from 'react';
import {formatNumber} from "../../../../lib/common";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {UnprocessedBankTransactionResponse} from "../../../../lib/types/types";
import {BankTransactionService} from "../../../../lib/services/bank-transaction-service";
import {useToast} from "../../../../lib/hooks/useToast";

interface Props {
    selectedTransaction: UnprocessedBankTransactionResponse;
    onClose: () => void;
}

const DiscardTransaction : React.FC<Props> = props => {
    const {formatMessage: f} = useIntl();
    const didMountRef = useRef(false);
    const toastHelpers = useToast();
    const bankService = new BankTransactionService(f, toastHelpers);

    const [discardReason, setDiscardReason] = useState<string>();

    useEffect(() => {
        if(!didMountRef.current) {
            didMountRef.current = true;
        }
    }, [])

    const handleDiscardTransaction = () => {
        if(!discardReason) return;
        bankService.discardTransaction(props.selectedTransaction.id, discardReason)
            .then(resp => {
                if(resp) {
                    props.onClose();
                }
            }).catch()
    }

    return <>
            <p>{f({id: 'confirmDiscardTransactionFromList'}, {clientName: props.selectedTransaction.clientName, amount: formatNumber(props.selectedTransaction.amount), description: props.selectedTransaction.paymentDetails})}</p>

            <div className={"grid p-fluid justify-content-center mt-4"}>
                <div className={"col-12"}>
                            <span className="p-float-label">
                                <InputText value={discardReason} onChange={(e) => setDiscardReason(e.target.value)}/>
                                <label>{f({id: "discardReason"})}</label>
                            </span>
                </div>

                <div className={"col-12 md:col-6"}>
                    <Button label={f({id: "remove"})} disabled={!discardReason}
                            onClick={handleDiscardTransaction}/>
                </div>

                <div className={"col-12 md:col-6"}>
                    <Button label={f({id: "cancel"})} onClick={props.onClose}/>
                </div>
            </div>
    </>
};

export default DiscardTransaction
